import { RootState } from 'data/root.reducers';
import { ServerResponse, WithAuditDetails } from 'data/types';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { showError, showSuccessMessage } from 'shared/toaster';
import { extractErrorMessage } from 'utils';
import i18n from 'i18n';
import { AxiosError } from 'axios';
import * as api from './network.api';
import {
  GET_NETWORKS,
  GetNetworksAction,
  CreateNetworkThunkAction,
  Network,
  OPEN_NETWORK_CREATE_POPUP,
  CLOSE_NETWORK_CREATE_POPUP,
  CREATE_NETWORK,
  OpenNetworkCreatePopupAction,
  CloseNetworkCreatePopupAction,
  SET_NETWORK_LOADING,
  SetNetworkLoadingAction,
} from './network.types';

export function openNetworkCreatePopup(network?: Network): OpenNetworkCreatePopupAction {
  return {
    type: OPEN_NETWORK_CREATE_POPUP,
    payload: { network },
  };
}

export function closeNetworkCreatePopup(): CloseNetworkCreatePopupAction {
  return {
    type: CLOSE_NETWORK_CREATE_POPUP,
  };
}

export function setNetworkLoadingAction(isLoading: boolean): SetNetworkLoadingAction {
  return {
    type: SET_NETWORK_LOADING,
    payload: { isLoading },
  };
}

export function getNetworks(deliveryFunctionId: string): GetNetworksAction {
  return {
    type: GET_NETWORKS,
    payload: api.getNetworks(deliveryFunctionId),
  };
}

export function createNetworkFromForm(
  deliveryFunctionId: string,
  body: WithAuditDetails<Network>,
): CreateNetworkThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    dispatch(setNetworkLoadingAction(true));

    try {
      await dispatch({
        type: CREATE_NETWORK,
        payload: api.createNetwork(deliveryFunctionId, body),
      });
      dispatch(closeNetworkCreatePopup());
      showSuccessMessage(i18n.t('network.create.success', { networkId: body.data?.networkId }), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e);
      showError(i18n.t('network.create.failed', { networkId: body.data?.networkId, error: errorMessage }));
    } finally {
      dispatch(setNetworkLoadingAction(false));
      dispatch(getNetworks(deliveryFunctionId));
    }
  };
}
